export default __webpack_public_path__ + "static/media/26.7e23ac24.png";